var SendToGraphDataType;
(function (SendToGraphDataType) {
    SendToGraphDataType[SendToGraphDataType["TEXT"] = 0] = "TEXT";
    SendToGraphDataType[SendToGraphDataType["PHOTO"] = 1] = "PHOTO";
})(SendToGraphDataType || (SendToGraphDataType = {}));
export default SendToGraphDataType;
